import type { Store } from "vuex";

/** Breaks AIService <-> getAIEndpoint circular import; set once from main.ts */
let vuexStoreRef: Store<any> | null = null;

export function setAIEndpointVuexStore(store: Store<any>): void {
  vuexStoreRef = store;
}

export function getAIEndpointVuexStore(): Store<any> | null {
  return vuexStoreRef;
}
